import { Injectable } from '@angular/core';
import { ROUTES } from '@shared/constants/routes.constant';
import { BehaviorSubject } from 'rxjs';
import { IConfiguracionVariables } from '../../interfaces/common.interface';
import { MenuItemModel } from '../../models/menu-item.model';
import { ExecutiveService } from '../executive/executive.service';
import { WealthPartnersService } from '../wealth-partners/wealth-partners.service';

@Injectable({
  providedIn: 'root',
})
export class SidebarMenuService {
  private menuItemsSubject = new BehaviorSubject<MenuItemModel[]>([]);

  public readonly menuItems$ = this.menuItemsSubject.asObservable();

  constructor(private executiveService: ExecutiveService, private wealthPartnerService: WealthPartnersService) {}

  initializeMenu() {
    const isSupervisor: boolean = this.executiveService.executiveModel.executiveProfile.isSupervisor ?? false;
    const isBoss: boolean = this.executiveService.executiveModel.executiveProfile.isBoss ?? false;
    const isNotBroker: boolean = this.executiveService.executiveModel.executiveProfile.isBroker ?? false;
    const sesionConfiguracionMenu = sessionStorage.getItem('configuracionVariables');
    const confMenu: IConfiguracionVariables = JSON.parse(sesionConfiguracionMenu);
    this.menuItemsSubject.next([
      {
        icon: isSupervisor || isBoss ? 'groups' : 'contacts',
        text: isSupervisor || isBoss ? 'Equipo de trabajo' : 'Cartera Clientes',
        iconType: 'outlined',
        url: '/main/client-portfolio',
        show: this.executiveService.executiveModel.executiveProfile.ownCustomers === true,
      },
      {
        icon: 'search',
        text: 'Buscador clientes',
        iconType: 'outlined',
        url: '/main/client-search',
        show: this.executiveService.executiveModel.executiveProfile.ownCustomers === false,
      },
      {
        icon: 'person_search',
        text: 'Cumplimiento',
        iconType: 'outlined',
        url: '/main/cumplimiento',
        show: true,
      },
      {
        icon: 'lock',
        iconType: 'outlined',
        text: 'Autorización SURA PASS',
        url: '/main/surapass/surapass-transacciones',
        show: true,
      },
      {
        text: confMenu.variables.TEXTO_MENU_FORMULARIO_UNICO.valor,
        icon: 'table_chart',
        iconType: 'outlined',
        url: confMenu.variables.URL_MENU_FORMULARIO_UNICO.valor,
        blank: true,
        show: !isNotBroker && confMenu.flags.HABILITAR_BOTON_FORM_UNICO_REGIONAL,
      },
      {
        icon: 'assignment',
        text: 'Fichas y Reglamentos',
        iconType: 'outlined',
        show: true,
        url: 'https://inversiones.sura.cl/sura/Paginas/Fondos-mutuos-fichas-y-reglamentos-.aspx',
        blank: true,
      },
      {
        icon: 'post_add',
        text: 'Formularios y Plantillas',
        show: !isNotBroker,
        url: 'https://gruposurachile.sharepoint.com/sites/Intranet/VPGerencia/Productos/Corredora/Paginas/Formularios-y-Contratos.aspx',
        blank: true,
      },
      {
        text: 'WORKFLOW DE INVERSIONES',
        icon: 'timeline',
        iconType: 'outlined',
        url: '/main/inversiones',
        show: !isNotBroker && confMenu.flags.HABILITAR_BOTON_HISTORICO_INVERSIONES,
      },
      {
        text: confMenu.variables.TEXTO_MENU_MANDATO_AFP.valor,
        icon: 'file_present',
        iconType: 'outlined',
        url: ROUTES.MANDATO.ROOT,
        show: confMenu.flags.HABILITAR_BOTON_MANDATO_AFP,
      },
      {
        text: 'Accesos directos',
        subtitle: '(Requieren Red SURA o VPN)',
        children: [
          {
            text: 'GUC',
            icon: 'vpn_key',
            iconType: 'outlined',
            url: 'http://gucprod.sura.cl/',
            blank: true,
            show: isNotBroker,
          },
          {
            text: 'ACIC',
            icon: 'group',
            iconType: 'outlined',
            url: 'http://acicwmweb/Operativo/AsignacionClaveAleatoria.aspx',
            blank: true,
            show: isNotBroker,
          },
          {
            text: 'VISUAL TIME',
            icon: 'verified_user',
            iconType: 'outlined',
            url: 'http://visualtimeindi/vtime/visualtime/visualtime.htm',
            blank: true,
            show: isNotBroker,
          },
          {
            text: 'BiZNET',
            icon: 'folder',
            iconType: 'outlined',
            url: 'http://biznet/aspx/Navegacion.aspx',
            blank: true,
            show: isNotBroker,
          },
          {
            text: 'Paneles comerciales',
            icon: 'table_chart',
            iconType: 'outlined',
            url: 'https://app.powerbi.com/groups/5ea12f76-fdf6-4aad-a9a0-58f573772cb5/reports/709a300a-e61b-4c39-9505-cf884e8dca8c?experience=power-bi&subfolderId=11556',
            blank: true,
            show: isNotBroker,
          },
          {
            text: 'Portfolio builder',
            icon: 'business_center',
            iconType: 'outlined',
            url: 'https://portfoliobuilder.sura.cl/Home/Index/',
            blank: true,
            show: isNotBroker,
          },
          {
            text: 'Productos e inversión',
            icon: 'analytics',
            iconType: 'outlined',
            url: 'https://surainvestmentsla.sharepoint.com/sites/Intranet/SitePages/Asesoria-y-productos-chile.aspx?e=eSc0c7&share=IQBQGz6zGQM4TZzv3BILYqTKARVAqALlTUQz8J4NKt0P6-E&xsdata=MDV8MDJ8UmF1bC5MdW5hQHN1cmFpbnZlc3RtZW50cy5jb218MDZmODc2MzM1ZDFmNDM2NjI5NjcwOGRlOWZhYjdmYzF8MmNiNGQxMjRjOWVkNDhjY2FlZmQyMjhjZDE1M2U4OTd8MHwwfDYzOTEyMzc1NjA5Mzg3MTY2NnxVbmtub3dufFRXRnBiR1pzYjNkOGV5SkZiWEIwZVUxaGNHa2lPblJ5ZFdVc0lsWWlPaUl3TGpBdU1EQXdNQ0lzSWxBaU9pSlhhVzR6TWlJc0lrRk9Jam9pVFdGcGJDSXNJbGRVSWpveWZRPT18MHx8fA%3d%3d&sdata=cUVHZmlTVk0wTjkwckV1aFZZWUFUTUloMzlScHFCaTVadTBiWWliM2FNMD0%3d',
            blank: true,
            show: isNotBroker,
          },
          {
            text: 'Soporte aplicaciones',
            icon: 'help_outline',
            iconType: 'outlined',
            url: 'http://soporteaplicaciones/Requerimientos/Requerimiento/NuevoRequerimiento',
            blank: true,
            show: isNotBroker,
          },
          {
            text: 'RYQ Corporativo',
            icon: 'report_gmailerrorred',
            iconType: 'outlined',
            url: 'http://ryqcorporativo/inicio.ASPX',
            blank: true,
            show: isNotBroker,
          },
          {
            text: 'PowerApps',
            icon: 'apps',
            iconType: 'outlined',
            url: 'https://apps.powerapps.com/play/e/default-2cb4d124-c9ed-48cc-aefd-228cd153e897/a/e4640ee6-2c57-41e6-a56a-f4a1ee6ac154?tenantId=2cb4d124-c9ed-48cc-aefd-228cd153e897&hint=8216ae40-bb1c-400a-883d-974434e9deb7&sourcetime=1720539058077#',
            blank: true,
            show: isNotBroker,
          },
          {
            icon: 'post_add',
            text: confMenu.variables.TEXTO_MENU_WEALTH_PARTNERS.valor,
            url: null,
            show: !(isNotBroker && confMenu.flags.HABILITAR_BOTON_WEALTH_PARTNERS),
            blank: true,
            isFnAction: true,
            fnAction: () => {
              this.wealthPartnerService.irALandingWealthPartners();
            },
          },
          {
            text: confMenu.variables.TEXTO_PANEL_INDICADORES_WP.valor,
            icon: 'table_chart',
            iconType: 'outlined',
            url: confMenu.variables.URL_PANEL_INDICADORES_WP.valor,
            blank: true,
            show: !(isNotBroker && confMenu.flags.HABILITAR_BOTON_PANELES_COMERCIALES_WP),
          },
          {
            text: 'Rentabilidad Diaria',
            icon: 'trending_up',
            iconType: 'outlined',
            url: 'https://app.powerbi.com/groups/me/reports/65cd0bee-5b84-4692-9c43-b8073cadf55d/429e7c6ba815b221aa20?ctid=2cb4d124-c9ed-48cc-aefd-228cd153e897&experience=power-bi&bookmarkGuid=c905a181-83f6-4196-abf7-cb8ac304e742',
            blank: true,
            show: isNotBroker,
          },
          {
            text: 'Agendamiento Advisor',
            icon: 'calendar_month',
            iconType: 'outlined',
            url: 'https://apps.powerapps.com/play/e/default-2cb4d124-c9ed-48cc-aefd-228cd153e897/a/717a39ac-b7c8-44eb-b89a-cbbb30a82684?tenantId=2cb4d124-c9ed-48cc-aefd-228cd153e897&hint=d769dac9-0f1b-487c-9071-3a0697ab609b&sourcetime=1785445645176',
            blank: true,
            show: isNotBroker,
          },
        ],
      },
      {
        text: 'Mantente informado',
        children: [
          {
            text: 'Noticias',
            icon: 'description',
            iconType: 'outlined',
            url: 'https://surainvestmentsla.sharepoint.com/sites/Tutoriales-y-noticias-web-SURA-Investments-CL',
            blank: true,
            show: isNotBroker,
          },
          {
            text: 'Tutoriales',
            icon: 'chrome_reader_mode',
            iconType: 'outlined',
            url: 'https://surainvestmentsla.sharepoint.com/sites/Tutoriales-y-noticias-web-SURA-Investments-CL/Tutoriales/Forms/AllItems.aspx',
            blank: true,
            show: isNotBroker,
          },
          {
            text: 'Somos comerciales',
            icon: 'local_library',
            iconType: 'outlined',
            url: 'https://gruposurachile.sharepoint.com/sites/Intranet/VPGerencia/Somos-Comerciales/Paginas/Somos-Comerciales.aspx',
            blank: true,
          },
        ],
      },
      {
        text: 'Información de mercado',
        children: [
          {
            text: 'Informes de Recomendación',
            icon: 'insert_chart_outlined',
            iconType: 'outlined',
            url: 'https://inversiones.sura.cl/nosotros/Paginas/informes-de-recomendacion.aspx',
            blank: true,
          },
          {
            text: 'Mercado financiero al día',
            icon: 'area_chart',
            iconType: 'outlined',
            url: 'https://inversiones.sura.cl/Inversiones/Paginas/informe-diario.aspx',
            blank: true,
          },
          {
            text: 'Podcast Inversiones SURA',
            icon: 'podcasts',
            iconType: 'outlined',
            url: 'https://inversiones.sura.cl/Inversiones/Paginas/podcast-sobre-asesoria-2020.aspx',
            blank: true,
          },
        ],
      },
    ]);
  }

  destroy() {
    this.menuItemsSubject.next(null);
  }
}
